import { Link } from 'react-router-dom';
import LobsterMascot from './LobsterMascot.jsx';
import { useTranslation } from '../i18n/I18nContext.jsx';
import { useLocalizedPath } from '../hooks/useLocalizedPath.js';

export default function PublicFooter() {
  const { t } = useTranslation();
  const lp = useLocalizedPath();
  const year = new Date().getFullYear();

  return (
    <footer className="pub-footer">
      <div className="pub-footer-inner">
        <div className="pub-footer-brand">
          <LobsterMascot size={40} />
          <div>
            <div className="pub-footer-name">{t('footer.brand')}</div>
            <div className="pub-footer-tagline">{t('footer.tagline')}</div>
          </div>
        </div>

        <nav className="pub-footer-cols" aria-label={t('footer.ariaLabel')}>
          <div className="pub-footer-col">
            <div className="pub-footer-col-title">{t('footer.colProduct')}</div>
            <Link to={lp('/')}>{t('footer.colProductHome')}</Link>
            <Link to={lp('/pricing')}>{t('footer.colProductPricing')}</Link>
            <Link to={lp('/login')}>{t('footer.colProductSignIn')}</Link>
          </div>
          <div className="pub-footer-col">
            <div className="pub-footer-col-title">{t('footer.colCompany')}</div>
            <Link to={lp('/contact')}>{t('footer.colCompanyContact')}</Link>
            <Link to={lp('/privacy')}>{t('footer.colCompanyPrivacy')}</Link>
            <Link to={lp('/terms')}>{t('footer.colCompanyTerms')}</Link>
          </div>
        </nav>
      </div>

      <div className="pub-footer-bottom">
        <span>{t('footer.copyright', { year })}</span>
        <span className="pub-footer-disclaimer">{t('footer.disclaimer')}</span>
      </div>
    </footer>
  );
}
